module.exports = __webpack_public_path__ + "@/assets/img/032-boy-13.4d6fbcda.svg";